export enum LicenceLevel {
  Free = 'Free',
  Professional = 'Professional',
  ProfessionalPlus = 'ProfessionalPlus',
  Agency = 'Agency',
  PremiumGen1 = 'Premium-Gen1',
  FreeGen1 = 'Free-Gen1',
  BusinessGen1 = 'Business-Gen1'
}

export const LicenceLevelValue = {
  [LicenceLevel.Free]: 0,
  [LicenceLevel.FreeGen1]: 1,
  [LicenceLevel.Professional]: 2,
  [LicenceLevel.ProfessionalPlus]: 3,
  [LicenceLevel.PremiumGen1]: 4,
  [LicenceLevel.BusinessGen1]: 5,
  [LicenceLevel.Agency]: 5
}

export enum FreeLicenseCategory {
  Free = 'Free',
  FreeEdu = 'FreeEdu',
  FreeGen1 = 'FreeGen1',
  FreeEduGen1 = 'FreeEduGen1'
}

export enum SelfServeLicenseCategory {
  Free = 'Free',
  FreeEdu = 'FreeEdu',
  FreeGen1 = 'FreeGen1',
  FreeEduGen1 = 'FreeEduGen1',
  Lite = 'Lite',
  LiteGen1 = 'LiteGen1',
  Pro = 'Pro',
  ProGen1 = 'ProGen1',
  Edu = 'Edu',
  EduGen1 = 'EduGen1',
  AgencyPromoGen1 = 'AgencyPromoGen1',
  AgencyGen1 = 'AgencyGen1',
}


export enum LicenseCategory {
  ECLimited = 'EC_Limited',
  ECEditor = 'EC_Editor',
  ECCreator = 'EC_Creator',
  Promo ='AgencyPromoGen1'
}

export enum LicencePlan {
  Free = 'Free',
  Starter = 'Starter',
  Pro = 'Pro',
  ProPlus = 'ProPlus',
  Agency = 'Agency',
  Edu = 'Edu',
  PremiumGen1 = 'Pro-Gen1',
  FreeGen1 = 'Free-Gen1',
  BusinessGen1 = 'Agency-Gen1'
}

export type LicenseGeneration = 0 | 1


export interface ILicenceGenOption {
  licenseGen: LicenseGeneration
}

export interface LicensedItem {
  licenseLevel: 'Free' |
    'Professional' |
    'ProfessionalPlus' |
    'Agency' |
    'Free-Gen1' |
    'Premium-Gen1' |
    'Edu-Gen1' |
    'Business-Gen1'
}

export interface FamiliesLicensedItem extends LicensedItem {
  families: string[]
}

export interface SoundPackagesLicensedItem extends LicensedItem {
  soundPackages: string[]
}
